import graphql__2f44c06dff3e90f6758f from "./__generated__/ContributionsDatavizSearchResults_participativeModule.graphql.js";import { graphql } from "react-relay";

import InfinitelyScrollableContainer from "../../../Utils/InfinitelyScrollableContainer";
import useFilterableContributionsList from "../useFilterableContributionsList";
import ContributionsDatavizListContributionsGrid from "./ContributionsDatavizListContributionsGrid";
import ContributionsDatavizListThemeContribution from "./ContributionsDatavizListThemeContribution";
import { useContributionsDatavizContext } from "./ContributionsDataviz";

const ContributionsDatavizSearchResults = props => {
  const { contributionsPerPage: resultsPerPage } = useContributionsDatavizContext();

  const { contributions, isLoading, loadMore, emptyListMessage } =
    useFilterableContributionsList({
      contribuable: props.participativeModule,
      fragment: ContributionsDatavizSearchResults_participativeModule,
      contributionsBatchSize: resultsPerPage
    });

  return (
    <InfinitelyScrollableContainer onBottomReached={loadMore}>
      <ContributionsDatavizListContributionsGrid>
        {contributions.map(contribution => (
          <ContributionsDatavizListThemeContribution
            key={contribution.id}
            contribution={contribution}
            theme={null}
          />
        ))}

        {/* Message displayed when there's no contribution, with a specific
            message, whether there is no contribution published, or if the
            filtered list has no results */}
        {emptyListMessage && <div className="box padding-md">{emptyListMessage}</div>}

        {/* Overlay displayed on top of contributions while the contributions
            list is reloaded, after the filters are updated */}
        {isLoading && <div className="container-overlay" />}
      </ContributionsDatavizListContributionsGrid>
    </InfinitelyScrollableContainer>
  );
};

export const ContributionsDatavizSearchResults_participativeModule = graphql__2f44c06dff3e90f6758f;

export default ContributionsDatavizSearchResults;
